import Swal from 'sweetalert2'
import seatingChartEmptyCart from './seating-chart-empty-cart.js'
import swalOpt, { swalOption } from '../components/swal-opt.js'
import { targetNext } from './targetNext'
import { btnLoadingDone } from '../components/loading.js'
import orphanSeatModal from './orphanSeatModal'
import handleError from './handelError'



window.existingSchedulesInCart = false

const hasMultiSchedules = (element: any): boolean => {
	if (element === 'existingSchedulesInCart') {
		window.existingSchedulesInCart = true
		return true
	}
	return false
}

const fallbackFn = (data: { message: any }, submitData: any) => {
	const errorMsg = data.message
	const isMultiSchedules = Object.values(errorMsg).some(hasMultiSchedules)

	if (isMultiSchedules) {
		Swal.fire(
			swalOpt(
				window.myvars.schedulePreventionMsg1,
				window.myvars.schedulePreventionMsg2,
				window.myvars.schedulePreventionMsg3
			)
		).then((result) => {
			if (result.value) {
				window.showLoading()
				seatingChartEmptyCart().then(
					(value) => {
						window.existingSchedulesInCart = false
						setTimeout(() => {
							postToCartFunc(submitData, targetNext())
							window.hideLoading()
						}, 5000)
					},
					(error) => {
						// rejection
						console.info(`postToCartFunc: ${error}`)
					}
				)
			} else {
				if (window.myvars.onePageCheckout) {
					window.location.href = '/store/checkout'
				} else {
					window.location.href = '/store/order/review-cart'
				}
			}
		})
	} else {
		const msg: string[] = errorMsg instanceof Array ? errorMsg : Object.values(errorMsg)
		$('#error-msg-holder-seating-chart').empty()

		// $.each(msg, (_key, value) => {
		// 	$('#error-msg-holder-seating-chart').append(`${value}<br/>`)
		// })

		for (const value of msg) {
			$('#error-msg-holder-seating-chart').append(`${value}<br/>`)
		}

		($('#error-msg-holder-wrapper-seating-chart') as any)
			.modal('show')

		// debugger
	}
}

// Shared with seating-chart postToCart.js:
export async function postToCartFunc(submitData: any, nextFunc: () => void) {
	return new Promise<void>((resolve, reject) => {
		// console.debug(`countSubmit: ${countSubmit}`)
		$.ajax({
			url: '/store/shopping-cart/add-ticket/ajax/1',
			type: 'POST',
			// data: 'items[]=Uu7kGQ4faa&items[]=L3yfYFgv3s&items[]=XITHHGyyfh',
			data: submitData,
			dataType: 'json',
			cache: false,
			timeout: 30000, // Set your timeout value in milliseconds or 0 for unlimited
			success: (payload, textStatus, xhr) => {
				// console.debug('submitData: ' + submitData)
				const data = { ...payload }
				btnLoadingDone('#select-tickets-add-to-cart-btn-md')
				btnLoadingDone('#best-available-add-to-cart-btn')
				if (data.status === 0) {
					// emptyCartSimple()
					fallbackFn(data, submitData)
					// if (fallback) fallback()
					resolve()
				} else if ((data.status === 2 || data.status === 3) && data.message) {
					// for orphan seat
					orphanSeatModal(data)
					resolve()
				} else if (data.status === 4 && data.message) {
					const errorMsg = data.message
					const msg: string[] = errorMsg instanceof Array ? errorMsg : Object.values(errorMsg)
					$('#error-msg-holder-seating-chart-anti-scalping').empty()

					for (const value of msg) {
						$('#error-msg-holder-seating-chart-anti-scalping').append(`${value}<br/>`)
					}

					($('#error-msg-holder-wrapper-seating-chart-anti-scalping') as any)
						.modal('show')

					resolve()
				} else {
					// alert(data.status)
					// debugger
					if (nextFunc) nextFunc()
					resolve()
				}
			},
			error: (jqXHR, exception, errorThrown) => {
				let msg = ''
				let promptMsg = window.myvars.serverError
				if (jqXHR.status === 0) {
					msg = 'Not connect.\n Verify Network.'
				} else if (jqXHR.status == 404) {
					msg = 'Requested page not found. [404]'
				} else if (jqXHR.status == 500) {
					msg = 'Internal Server Error [500].'
				} else if (exception === 'parsererror') {
					msg = 'Requested JSON parse failed.'
				} else if (exception === 'timeout') {
					promptMsg = window.myvars.timeoutErrorWhileTicketing // Handle other error type
					msg = 'Time out error.'
				} else if (exception === 'abort') {
					msg = 'Ajax request aborted.'
				} else {
					msg = 'Uncaught Error.\n' + jqXHR.responseText
				}

				console.debug(errorThrown)


				const resolution = window.displayResolution()
				window.postAjax(
					'/index/js-error',
					{
						error: msg,
						script: window.location.href,
						line: '-',
						col: '-',
						browser: window.BrowserDetect.browser,
						browserVersion: window.BrowserDetect.version,
						os: window.getOS(),
						orientation: window.getOrientation(),
						resolutionWidth: resolution.width,
						resolutionHeight: resolution.height,
					},
					() => {
						handleError(promptMsg) // Handle other error type
						window.location.reload()
					}
				)
				// if (exception === 'timeout') {
				// 	alert(window.myvars.timeoutErrorWhileTicketing) // Handle other error type
				// 	window.location.reload(true)
				// } else {
				// }
				reject(errorThrown)
			},
		})
	})
}



export default postToCartFunc
